







import { Component, Prop, Vue } from 'vue-property-decorator';
import Amplify, { API } from 'aws-amplify';

@Component
export default class Home extends Vue {
  @Prop() private msg!: string;

  private submitting: boolean = false;

  private config() {
    this.submitting = true;
    Amplify.configure({
      API: {
        endpoints: [
          {
            name: 'test',
            endpoint: 'https://api.test2.ommdev.work',
          },
        ],
      },
    });
    this.submitting = false;
  }

  private async invoke() {
    this.submitting = true;

    const ret = await API.get('test', '/hello', {});
    // console.log(ret);
    this.submitting = false;
  }
}
